import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArquivosAnexadosView } from '../model/view/ArquivosAnexadosView';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnexosService {
  private BASE_URL = './rest/anexo'
  
  constructor(private http: HttpClient) { }
  
  obterAnexos(idPAC: number): Observable<ArquivosAnexadosView[]>{
    return this.http.get<ArquivosAnexadosView[]>(this.BASE_URL+"/"+idPAC)
  }
  
  linkDownload(a: ArquivosAnexadosView): string {
    return this.BASE_URL+"/download/"+a.id
  }
}
